export const splitIntoBlocks = <T,>(array: T[] | undefined, size: number) => {
  const blocks = [];

  if (array) {
    for (let i = 0; i < array.length; i += size) {
      blocks.push(array.slice(i, i + size));
    }
  }

  return blocks;
};
